/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} B2b_Hero_HighlightInputs */

const en_b2b_hero_highlight = /** @type {(inputs: B2b_Hero_HighlightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sovereign Commerce for Enterprise.`)
};

const es_b2b_hero_highlight = /** @type {(inputs: B2b_Hero_HighlightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comercio Sovereign para Empresas.`)
};

const fr_b2b_hero_highlight = /** @type {(inputs: B2b_Hero_HighlightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Commerce Sovereign pour l'Entreprise.`)
};

const de_b2b_hero_highlight = /** @type {(inputs: B2b_Hero_HighlightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sovereign Commerce für Unternehmen.`)
};

const id_b2b_hero_highlight = /** @type {(inputs: B2b_Hero_HighlightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perdagangan Sovereign untuk Perusahaan.`)
};

/** @type {(inputs: B2b_Hero_HighlightInputs) => LocalizedString} */
const ja_b2b_hero_highlight = en_b2b_hero_highlight;

/** @type {(inputs: B2b_Hero_HighlightInputs) => LocalizedString} */
const zh_b2b_hero_highlight = en_b2b_hero_highlight;

/** @type {(inputs: B2b_Hero_HighlightInputs) => LocalizedString} */
const ar_b2b_hero_highlight = en_b2b_hero_highlight;

/** @type {(inputs: B2b_Hero_HighlightInputs) => LocalizedString} */
const it_b2b_hero_highlight = en_b2b_hero_highlight;

/** @type {(inputs: B2b_Hero_HighlightInputs) => LocalizedString} */
const ru_b2b_hero_highlight = en_b2b_hero_highlight;

/** @type {(inputs: B2b_Hero_HighlightInputs) => LocalizedString} */
const pt_b2b_hero_highlight = en_b2b_hero_highlight;

/** @type {(inputs: B2b_Hero_HighlightInputs) => LocalizedString} */
const ko_b2b_hero_highlight = en_b2b_hero_highlight;

/**
* | output |
* | --- |
* | "Sovereign Commerce for Enterprise." |
*
* @param {B2b_Hero_HighlightInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const b2b_hero_highlight = /** @type {((inputs?: B2b_Hero_HighlightInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<B2b_Hero_HighlightInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_b2b_hero_highlight(inputs)
	if (locale === "es") return es_b2b_hero_highlight(inputs)
	if (locale === "fr") return fr_b2b_hero_highlight(inputs)
	if (locale === "de") return de_b2b_hero_highlight(inputs)
	if (locale === "ja") return ja_b2b_hero_highlight(inputs)
	if (locale === "zh") return zh_b2b_hero_highlight(inputs)
	if (locale === "ar") return ar_b2b_hero_highlight(inputs)
	if (locale === "id") return id_b2b_hero_highlight(inputs)
	if (locale === "it") return it_b2b_hero_highlight(inputs)
	if (locale === "ru") return ru_b2b_hero_highlight(inputs)
	if (locale === "pt") return pt_b2b_hero_highlight(inputs)
	return ko_b2b_hero_highlight(inputs)
});